"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInjectedRef = exports.getGroup = exports.isGroup = exports.getGroups = exports.Group = exports.GROUP_ID = void 0;
const react_1 = require("react");
const types_1 = require("../../../types");
const DEFAULT_EXIT_DIRECTIONS = [types_1.FocusDirection.Up, types_1.FocusDirection.Down, types_1.FocusDirection.Left, types_1.FocusDirection.Right];
let groupCounter = 0;
exports.GROUP_ID = 'data-group';
class Group extends react_1.Component {
    constructor(props) {
        super(props);
        this.getId = () => {
            if (this.state.id === -1) {
                return undefined;
            }
            return this.state.id.toString();
        };
        this.getElement = () => {
            return this.props.innerDivRef.current;
        };
        this.onUp = () => {
            if (this.props.onUp) {
                return this.props.onUp();
            }
            return false;
        };
        this.onDown = () => {
            if (this.props.onDown) {
                return this.props.onDown();
            }
            return false;
        };
        this.onLeft = () => {
            if (this.props.onLeft) {
                return this.props.onLeft();
            }
            return false;
        };
        this.onRight = () => {
            if (this.props.onRight) {
                return this.props.onRight();
            }
            return false;
        };
        this.onEnter = () => { var _a, _b; return (_b = (_a = this.props).onEnter) === null || _b === void 0 ? void 0 : _b.call(_a); };
        this.onExit = () => { var _a, _b; return (_b = (_a = this.props).onExit) === null || _b === void 0 ? void 0 : _b.call(_a); };
        this.onTab = () => {
            if (this.props.onTab) {
                return this.props.onTab();
            }
            return false;
        };
        this.onTabExit = () => { var _a, _b; return (_b = (_a = this.props).onTabExit) === null || _b === void 0 ? void 0 : _b.call(_a); };
        this.containsExitDirection = (direction) => {
            var _a;
            return (_a = this.props.exitDirections) === null || _a === void 0 ? void 0 : _a.includes(direction);
        };
        this.getExitDirections = () => {
            return this.props.exitDirections;
        };
        this.getTabBehavior = () => {
            var _a;
            return (_a = this.props.tabBehavior) !== null && _a !== void 0 ? _a : types_1.TabBehavior.All;
        };
        this.getBoundsShift = () => {
            return this.props.boundsShift;
        };
        this.isInGrid = () => {
            return !!this.props.grid;
        };
        this.getGroupPositioning = () => {
            return this.props.groupPositioning;
        };
        this.doesCaptureFocus = () => {
            return this.props.capturesFocus;
        };
        this.state = {
            id: -1,
        };
    }
    async componentDidMount() {
        await this.setState({
            id: groupCounter++,
        }, () => registerGroup(this));
    }
    componentWillUnmount() {
        unregisterGroup(this);
    }
}
exports.Group = Group;
Group.defaultProps = {
    exitDirections: DEFAULT_EXIT_DIRECTIONS,
    groupPositioning: types_1.GroupPositioning.Disabled,
    capturesFocus: false,
};
// Map of container id to Group for finding focus group objects from div elements
const groupIdMap = new Map();
const getGroups = () => {
    return Array.from(groupIdMap.values());
};
exports.getGroups = getGroups;
// Registers a focus group so that it can be found from its ID
const registerGroup = (group) => {
    const id = group.getId();
    if (id) {
        groupIdMap.set(id, group);
    }
};
// When unmounted, remove references to the focus group for cleanup
const unregisterGroup = (group) => {
    const id = group.getId();
    if (id) {
        groupIdMap.delete(id);
    }
};
const isGroup = (element) => {
    return (0, exports.getGroup)(element) !== undefined;
};
exports.isGroup = isGroup;
const getGroup = (element) => {
    if (!element) {
        return;
    }
    if (element.hasAttribute && element.hasAttribute(exports.GROUP_ID)) {
        const id = element.getAttribute(exports.GROUP_ID);
        if (id) {
            return groupIdMap.get(id);
        }
    }
};
exports.getGroup = getGroup;
const hasInjectedRef = (props) => {
    return 'injectedRef' in props && props.injectedRef !== null && props.injectedRef !== undefined;
};
exports.hasInjectedRef = hasInjectedRef;
//# sourceMappingURL=data:application/json;base64,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